import styled from 'styled-components';
import { Text } from '@zillow/constellation';

export const StatContainer = styled.div<{ isSmallScreen: boolean }>`
    width: ${({ isSmallScreen }) => (isSmallScreen ? '135px' : '200px')};
`;

export const StatName = styled(Text)`
    white-space: nowrap;
`;
